// SQL to array values for each type - Set SQL query to text output CTRL + T in SQL Server Management Studio
// (have to remove the leading // )
// Note that the ids are strings as this is what the drop down control expects

// SET NOCOUNT ON
// SELECT cast('{ label: "' + Name + '", value: "' + CAST(TimeRangesId AS varchar) + '" },' as varchar(max))
// FROM MuellerHomeowner.dbo.TimeRanges cpt
// ORDER BY TimeRangesId
export const timeRanges = [
  { label: "8AM-Noon", value: "1" },
  { label: "Noon-4PM", value: "2" },
  { label: "4PM-8PM", value: "3" },
];

// SET NOCOUNT ON
// SELECT cast('{ label: "' + Name + '", value: "' + CAST(Code AS varchar) + '" },' as varchar(max))
// FROM MuellerHomeowner.dbo.ContactPersonTypes cpt
// ORDER BY ContactPersonTypesId
export const contactPersonTypes = [
  { label: "Policyholder", value: "INSURED" },
  { label: "Agent", value: "AGENT" },
  { label: "Mueller Customer Service", value: "MUELLER_CS" },
  { label: "Mueller Manager", value: "MUELLER_MGR" },
  { label: "Underwriter", value: "UNDERWRITER" },
  { label: "Required Third Party", value: "REQUIRED_THIRD_PARTY" },
  { label: "Designated Contact", value: "DESIGNATED" },
];

// SET NOCOUNT ON
// SELECT cast('{ label: "' + Name + '", value: "' + CAST(Code AS varchar) + '", sort: ' + CAST(Sort AS varchar) + ' },' as varchar(max))
// FROM MuellerHomeowner.dbo.ContactEffortResultTypes cpt
// ORDER BY Sort
export const contactEffortResultTypes = [
  { label: "Alternate Contact number obtained", value: "AltNumberObtained", sort: 10 },
  { label: "Appointment Scheduled", value: "PHAccepted", sort: 10 },
  { label: "Requested PH number", value: "PHInfoRequest", sort: 10 },
  { label: "Permission Obtained", value: "PermissionGranted", sort: 20 },
  { label: "Directions Obtained", value: "AgencyDirectionObtained", sort: 20 },
  { label: "Requested agency name &/or number", value: "AgencyInfoRequest", sort: 20 },
  { label: "Instructed to Close Out the survey", value: "CloseOutSurvey", sort: 30 },
  { label: "Directions Obtained", value: "DirectionsObtained", sort: 30 },
  { label: "Agency will contact PH on Mueller's behalf", value: "AgentMuellersBehalf", sort: 30 },
  { label: "Agency unable to assist", value: "AgencyUnableAssist", sort: 40 },
  { label: "Instructed to Convert to Exterior survey", value: "ConvertToExt", sort: 40 },
  { label: "Left Voicemail", value: "MessagePHMachine", sort: 40 },
  { label: "Requested Permission to Close Out", value: "RequestedPermissionToClose", sort: 45 },
  { label: "Left voicemail (unidentified by name)", value: "MessageUNKMachine", sort: 50 },
  { label: "Left voicemail", value: "AgencyMessageMachine", sort: 50 },
  { label: "Request assistance with Manager", value: "ManagerAssistNeeded", sort: 50 },
  { label: "Left message with agency staff", value: "AgencyMessageStaff", sort: 60 },
  { label: "Left Message with PH, Spouse, or Other", value: "MessagePH", sort: 60 },
  { label: "Left message with an adult other than PH or spouse", value: "MessageADULT", sort: 80 },
  { label: "Wrong Number or Out of Service", value: "AgencyWrongNumber", sort: 80 },
  { label: "Number out of service", value: "OutOfService", sort: 90 },
  { label: "No Voicemail / Voicemail Full", value: "AgencyNoAnswerNoMachine", sort: 90 },
  { label: "Wrong Number or out of service", value: "WrongNumber", sort: 100 },
  { label: "Requested Permission to Extend", value: "RequestedPermissionToExtend", sort: 100 },
  { label: "No Voicemail / Voicemail Full", value: "NoAnswer", sort: 110 },
  { label: "(Unsuccessful Pre-notification) No contact number available/developed", value: "PreNoteFailedNC", sort: 120 },
  { label: "PH refused survey", value: "PHRefused", sort: 130 },
  { label: "PH Hung-up / Refused Call", value: "PHDeclined", sort: 140 },
  { label: "Unable to leave message due to language barrier", value: "NotEnglish", sort: 150 },
  { label: "PH does not own or have access", value: "PHNoAccess", sort: 160 },
  { label: "Left message with other", value: "MessageOther", sort: 170 },
  { label: "Requested Call Back / Additional Call Required", value: "RequestedCallBack", sort: 175 },
  { label: "(Unsuccessful Pre-notification) No answer & no voicemail", value: "PreNoteFailedNA", sort: 180 },
  { label: "(Successful Pre-notification) Left voicemail", value: "PreNoteMessageMachine", sort: 190 },
  { label: "(Successful Pre-notification) Left message with PH", value: "PreNotePH", sort: 200 },
  { label: "Text message sent", value: "TextMessageSent", sort: 210 },
  { label: "Appointment text sent", value: "AppointmentTextSent", sort: 220 },
  { label: "Prenotification text sent", value: "PrenotificationTextSent", sort: 230 },
  { label: "Reminder text sent", value: "ReminderTextSent", sort: 240 },
  { label: "Email Sent", value: "EmailSent", sort: 245 },
  { label: "(Successful M@H) Text Message Link Sent", value: "MuellerAtHomeText", sort: 250 },
  { label: "(Successful M@H) Email Link Sent", value: "MuellerAtHomeEmail", sort: 260 },
  { label: "(Successful M@H) M@H Scheduled", value: "MuellerAtHomeScheduled", sort: 270 },
  { label: "(Unsuccessful M@H) PH Refused Survey", value: "MuellerAtHomeRefused", sort: 280 },
  { label: "Post Inspection Follow-up Call: Message Left", value: "PostInspectionMessageLeft", sort: 290 },
  { label: "Post Inspection Follow-up Call: Completed Review", value: "PostInspectionCompletedReview", sort: 300 },
  { label: "Post Inspection Follow-up Vall: Unsuccessful Contact", value: "PostInspectionUnsuccessfulContact", sort: 310 },
  { label: "Fire Department Call: Message Left", value: "FireDepartmentMessageLeft", sort: 320 },
  { label: "Fire Department Call: Form Complete", value: "FireDepartmentFormComplete", sort: 330 },
  { label: "Fire Department Call: Unsuccessful Contact", value: "FireDepartmentUnsuccessfulContact", sort: 340 },
];

export const contactTypeCodes = {
  E: "E",
  P1: "P1",
  P2: "P2",
  MT: "MT",
  M1: "M1",
  M2: "M2",
  E0: "E0",
  H1: "H1",
  H2: "H2",
  C1: "C1",
  W1: "W1",
  W2: "W2",
  E1: "E1",
  E2: "E2",
  AE: "AE",
  F: "F",
  A1: "A1",
  A2: "A2",
  X1: "X1",
  X2: "X2",
  X3: "X3",
  X4: "X4",
  D1: "D1",
  D2: "D2",
  DE: "DE",
};